import { render, staticRenderFns } from "./DocumentationRaw.vue?vue&type=template&id=60d659fd&"
import script from "./DocumentationRaw.vue?vue&type=script&lang=js&"
export * from "./DocumentationRaw.vue?vue&type=script&lang=js&"
import style0 from "./DocumentationRaw.vue?vue&type=style&index=0&id=60d659fd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports